"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M18 10V7c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3c-1.1 0-2 .9-2 2v5h1.33l.51 1.53c.1.28.36.47.66.47s.56-.19.66-.47L7.67 17h8.67l.51 1.53c.09.28.35.47.65.47s.56-.19.66-.47l.51-1.53H20v-5c0-1.1-.9-2-2-2m-7 0H8V8c0-.55.45-1 1-1h2zm5 0h-3V7h2c.55 0 1 .45 1 1z"
}), 'SingleBedRounded');